import { axiosYtApiV2 } from "@/services/axios-yt-api-v2.js";

const axiosUtilities = {
  convertCurrency(sum,fromCurrency,toCurrency) {
    return axiosYtApiV2.get(`currency/convert?sum=${sum}&fromCurrency=${fromCurrency}&toCurrency=${toCurrency}`);
  }
}
export { axiosUtilities };
